import React from 'react'
import Tooltip from 'components/tooltips/Tooltips'
import ModalIconTile from 'components/modal/components/iconTile'
import ModalCloseButton from 'components/modal/components/closeButton'
import 'styles/main.scss'

// `closeLabel` is opt-in so the many other modals sharing this header stay as they are.
// `icon` puts a pictogram tile above the title (ModalIconTile tone, e.g. 'danger').
// `description` sits 6px under the title, in the header block (Figma "Fenêtre").
const Modalheader = ({children,hide,hideShow,closeLabel,icon,description}) => {
    const closeButton = <ModalCloseButton onClick={hide} label={closeLabel} className="ml-auto"/>

    return (
        <div className={`flex justify-between gap-4 px-6 pt-8 rounded-t ${icon || description ? 'items-start' : 'items-center'}`}>
            <div className="flex min-w-0 flex-col">
                {icon ? <div className="mb-4"><ModalIconTile tone={icon}/></div> : null}
                <h3 className="text-2xl leading-[30px] text-[#202124] font-medium">
                    {children}
                </h3>
                {description ? <p className="mt-1.5 text-sm leading-5 text-gray-600">{description}</p> : null}
            </div>
            {hideShow ? (
                closeLabel ? (
                    // Below the cross, as in the other modal headers.
                    <div className="ml-auto">
                        <Tooltip text={closeLabel} placement="bottom">
                            {closeButton}
                        </Tooltip>
                    </div>
                ) : closeButton
            ) : ''}
        </div>
    )
}

export default Modalheader
